var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"recharge-status"},[_c('Tag',{attrs:{"color":_vm.nodeStateTagText.color}},[_vm._v(_vm._s(_vm.nodeStateTagText.label))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }